import { computed, ref } from 'vue'
import { useCurrentFeatureFilters } from './useFilters'
import { useStore } from 'vuex'
import { defineStore } from 'pinia'
import { useSelectionStore } from '@/pinia/selectionNew'

export type EntityLevel =
  | 'REGION'
  | 'COMPLEX'
  | 'REAL_ESTATE'
  | 'CONSTRUCTION'
  | 'LEVEL'
  | 'FLOOR'
  | 'SPACE'

export const useEntityLevel = defineStore('EntityLevel', () => {
  const filters = useCurrentFeatureFilters()
  const selection = useSelectionStore()
  const currentEntityType = computed(
    () => selection.selectedEntityType ?? filters.value?.submittedMeta.entityType
  )
  const store = useStore()
  const allEntityLevels = (): EntityLevel[] => [
    'REGION',
    'COMPLEX',
    'REAL_ESTATE',
    'CONSTRUCTION',
    'LEVEL',
    'FLOOR',
    'SPACE'
  ]
  const enabledEntityLevels = ref<EntityLevel[]>(allEntityLevels())

  const entityLevel = computed(() => {
    switch (currentEntityType.value) {
      case 'COMPLEX':
        return 'COMPLEX'
      case 'REAL_ESTATE':
        return 'REAL_ESTATE'
      case 'CONSTRUCTION':
        return 'CONSTRUCTION'
      case 'LEVEL':
        if (store.getters.isPlanviewShowing) {
          return 'FLOOR'
        }
        return 'LEVEL'
      case 'SPACE':
        return 'SPACE'
      default:
        return 'REGION'
    }
  })

  function setEnabled(levels: EntityLevel[]) {
    enabledEntityLevels.value = levels
  }

  function resetEnabled() {
    enabledEntityLevels.value = allEntityLevels()
  }

  return {
    entityLevel,
    enabledEntityLevels,
    setEnabled,
    resetEnabled
  }
})
